module.exports = __webpack_public_path__ + "img/49.8413af63.jpg";